import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import { ViewVariant } from "@/common/ts/layout";
import { CustomerDto } from "@/core/api/generated/v1";

import ChargePaginatedList from "../../../Charge/ListView/ChargePaginatedList";

interface Props {
  customer: CustomerDto;
}

export default function ChargesTabContent({ customer }: Props) {
  return (
    <PageTabContent>
      <ChargePaginatedList
        defaultValues={{
          customerId: customer.id!,
        }}
        displayProps={{
          viewVariant: ViewVariant.Tab,
          header: false,
          counters: false,
        }}
      />
    </PageTabContent>
  );
}
